module.exports = __webpack_public_path__ + "media/bootstrap-icons/umbrella-fill-ff8c6148.svg";